export default {
    data: () => ({
        translations: {
            addPaymentMethod: {
                el: "Προσθήκη Τρόπου Πληρωμής",
                en: "Add Payment Method",
                it: "Aggiungi metodo di pagamento"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            description: {
                el: "Περιγραφή",
                en: "Description",
                it: "Descrizione"
            },
            image: {
                el: "Εικόνα",
                en: "Image",
                it: "Immagine"
            },
            actions: {
                el: "Επεξεργασία",
                en: "Actions",
                it: "Modifica"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            showAdditionalInfo: {
                el: "Προβολή",
                en: "View",
                it: "Vedi"
            },
            additionalInfo: {
                el: "",
                en: "Payment Method Additional Info",
                it: ""
            },
            color: {
                el: "Επιλογή Χρώματος",
                en: "Color",
                it: "Selezione del colore"
            },
            fields: {
                el: "",
                en: "Payment Method Fields",
                it: ""
            },
            credentials: {
                el: "",
                en: "Credentials",
                it: ""
            },
            onlineOffline: {
                el: "Online/Offline",
                en: "Online/Offline",
                it: "Online/Offline"
            },
            modalTitle1:{
                el: "Προσθήκη Τρόπου Πληρωμής",
                en: "Add Payment Method",
                it: "Aggiungi metodo di pagamento" 
            },
            modalTitle2:{
                el: "Ενημέρωση",
                en: "Update Payment Method",
                it: "Aggiornamento" 
            },
            systemPaymentMethod:{
                el: "Τρόπος Πληρωμής",
                en: "System Payment Method",
                it: "Metodi di Pagamento" 
            },
        }
    })
};
